/** Branding mode options shared across offer creation and edit forms. */
export const BRANDING_MODE_OPTIONS = [
  { value: 'RW_GROUP', labelKey: 'workspace.header.options.brandingMode.rwGroup' },
  { value: 'WHITE_LABEL', labelKey: 'workspace.header.options.brandingMode.whiteLabel' },
] as const;
